import { useRef, useMemo, useCallback } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "@/styles/article.css";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const RichTextEditor = ({ value, onChange }) => {
  const quillRef = useRef(null);

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
        const editor = quillRef.current?.getEditor?.();
        if (!editor) return;
        const range = editor.getSelection(true);
        editor.insertEmbed(range.index, "image", data.url);
        editor.setSelection(range.index + 1);
      } catch {
        toast.error("No se pudo subir la imagen");
      }
    };
    input.click();
  }, []);

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ header: [2, 3, false] }],
        ["bold", "italic", "underline", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
      handlers: { image: imageHandler },
    },
  }), [imageHandler]);

  return (
    <div className="rte-wrap" data-testid="rich-text-editor">
      <ReactQuill ref={quillRef} theme="snow" value={value || ""} onChange={onChange} modules={modules} />
    </div>
  );
};
